"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.divideResearchActivities = exports.combineTools = exports.divideTools = void 0;
const types_1 = require("./types");
const divideTools = (tools) => {
    const planningTools = [];
    const designTools = [];
    const implementationTools = [];
    const otherTools = [];
    tools.forEach((tool) => {
        switch (tool) {
            case types_1.DocumentationTools.EMPLOYEE_CALENDARS:
            case types_1.DocumentationTools.MEETING_AGENDAS:
            case types_1.DocumentationTools.EMAILS:
            case types_1.DocumentationTools.MEETING_MINUTES:
            case types_1.DocumentationTools.GANTT_CHARTS:
            case types_1.DocumentationTools.PROJECT_MANAGEMENT_SOFTWARE:
                planningTools.push(tool);
                break;
            case types_1.DocumentationTools.ARCHITECTURE_DIAGRAMS:
            case types_1.DocumentationTools.PROTOTYPE_BUILD_SHEETS:
            case types_1.DocumentationTools.COMPUTATIONAL_DOCUMENTS:
            case types_1.DocumentationTools.PROCESS_CHARTS:
            case types_1.DocumentationTools.DESIGN_PROTOTYPES:
            case types_1.DocumentationTools.CONCEPT_DRAWINGS:
            case types_1.DocumentationTools.MOCKUPS:
                designTools.push(tool);
                break;
            case types_1.DocumentationTools.SOFTWARE_SOURCE_CODE:
            case types_1.DocumentationTools.COMMIT_LOGS:
            case types_1.DocumentationTools.PULL_REQUESTS:
            case types_1.DocumentationTools.CLOUD_COMPUTING:
            case types_1.DocumentationTools.RELEASE_NOTES:
            case types_1.DocumentationTools.API_USAGE:
            case types_1.DocumentationTools.API_DOCS:
            case types_1.DocumentationTools.LAB_TESTS:
                implementationTools.push(tool);
                break;
            default:
                otherTools.push(tool);
                break;
        }
    });
    return { planningTools, designTools, implementationTools, otherTools };
};
exports.divideTools = divideTools;
const combineTools = (toolsArrays) => {
    const { designTools, implementationTools, otherTools, planningTools } = toolsArrays;
    return [...planningTools, ...designTools, ...implementationTools, ...otherTools];
};
exports.combineTools = combineTools;
const divideResearchActivities = (allActivities) => {
    const researchActivities = [];
    const patentDescriptions = [];
    allActivities.forEach((activity) => {
        switch (activity) {
            case types_1.ResearchActivities.RESEARCH_PAPERS:
            case types_1.ResearchActivities.WHITE_PAPERS:
            case types_1.ResearchActivities.PATENTS:
                researchActivities.push(activity);
                break;
            default:
                patentDescriptions.push(activity);
                break;
        }
    });
    return { researchActivities, patentDescriptions };
};
exports.divideResearchActivities = divideResearchActivities;
